"use client";
import React, { useEffect } from "react";
import gsap from "gsap";
import NavBar from "@/app/sections/NavBar";

const IntroAnimation: React.FC = () => {
    useEffect(() => {
        const tl = gsap.timeline({
            defaults: { ease: "power2.inOut" }
        });

        tl.to(".intro-overlay", {
            duration: 1.2,
            y: "-100%",
            ease: "power2.inOut"
        })
        .from(".navbar-container", {
            duration: 0.8,
            opacity: 0,
            y: -20,
            ease: "power2.out"
        }, "-=0.6")
        .to(".intro-overlay", {
            duration: 0,
            display: "none"
        });
    }, []);

    return (
        <>
            <div 
                className="intro-overlay fixed inset-0 bg-black z-50"
                style={{ transform: "translateY(0%)" }}
            />
            <div className="navbar-container">
            </div>
        </>
    );
};

export default IntroAnimation; 